export const Apis = {
    // server:'http://192.168.100.22:8003',
    // server:'http://127.0.0.1:8003',
    server:'https://auto.nahalmaharat.ir',
    domainName:'nahalmaharat.ir',
};